<div class="not-authorized">
  <div class="not-authorized__content">
    <div class="not-authorized__code">401</div>
    <div class="not-authorized__copy">
      <h4>{{ 'notAuthorized.description' | translate }}</h4>
      <p>{{ 'notAuthorized.description' | translate }}</p>
      <img src="assets/img/brand/PEGASI-SAIL.svg" alt="PEGASI SAIL" />
    </div>
  </div>
</div>
